export default __webpack_public_path__ + "static/media/logo.8267f753.svg";